<template>
    <Head title="FAQ" />

    <Authenticated :showBackButton="false" >
    <Heading title="Perguntas Frequentes" class="xl:px-[280px] px-4 pt-24 sm:pt-28"/>
    <div>
        <div class="px-2.5 pb-[35px] pt-5 xl:mx-[280px] min-h-[70vh]">
            <button @click="goBack" class="back-sm hover:text-blue-600 hover:underline text-sm text-[#2E59FF] pb-6">Voltar</button>
            <Topic v-for="(topic,key) in faq.data" :key="key" :title="topic.name" :accordions="topic.questions" class="w-[600px]" />
        </div>
    </div>
    </Authenticated>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3';
import Heading from '@/Components/UI/Texts/Heading.vue'
import Authenticated from "@/Layouts/Authenticated.vue"
import Topic from "@/Components/Topic.vue"
import Accordion from "@/Components/UI/Modals/Accordion.vue"

export default {
  components: {
    Heading,
    Head,
    Accordion,
    Topic,
    Authenticated
  },
  props: {
      faq: Object
  },
  methods: {
        goBack(){
            return window.history.go(-1);
        }
    }
}
</script>
